import { isValidStoreUrl, normalizeStoreUrl } from "features/dataConnectors/utils/normalizeStoreUrl";
import { ValidatorForm } from "react-material-ui-form-validator";

const STORE_URL_REGEX =
  /https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/;

export { isValidStoreUrl };

export const isValidEmail = (value: string): boolean => {
  if (!value.trim()) {
    return false;
  }

  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(value.trim());
};

export const isValidPersonName = (value: string): boolean => {
  if (!value.trim()) {
    return false;
  }

  const trimmed = value.trim();
  const regex = /^[\p{L}][\p{L}\s'.-]{1,127}$/u;
  return regex.test(trimmed);
};

export const setupCustomValidators = () => {
  ValidatorForm.addValidationRule("isDomain", (value) => {
    if (value === "") {
      return true;
    }

    const regex =
      /https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&\/\/=]*)/;
    return regex.test(value);
  });
  ValidatorForm.addValidationRule("isSubdomain", (value) => {
    if (value === "") {
      return true;
    }

    const regex = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
    return regex.test(value);
  });
  ValidatorForm.addValidationRule("isPath", (value) => {
    if (value === "") {
      return true;
    }

    const regex = /^(?!\/)[a-zA-Z0-9/\-_.]*$/;
    return regex.test(value);
  });
  ValidatorForm.addValidationRule("isStoreUrl", (value) => {
    if (value === "") {
      return true;
    }

    return STORE_URL_REGEX.test(normalizeStoreUrl(value));
  });
  ValidatorForm.addValidationRule("isPersonName", (value) => {
    if (value === "") {
      return true;
    }

    return isValidPersonName(value);
  });
  return () => {
    ValidatorForm.removeValidationRule("isSubdomain");
    ValidatorForm.removeValidationRule("isDomain");
    ValidatorForm.removeValidationRule("isPath");
    ValidatorForm.removeValidationRule("isStoreUrl");
    ValidatorForm.removeValidationRule("isPersonName");
  };
};
